import { useMutation } from '@tanstack/react-query';
import { Button } from '@givebutter/primitives/button';
import { updateRewardStatus as updateRewardStatusApi } from 'api/onboarding';
import { STICKER_FORM_LINK } from 'constants/links';
import { useCurrentAccount } from 'customHooks/useCurrentAccount';
import ChangeMaker from 'images/change-maker-sticker.png';
import Logo from 'images/logo-sticker.svg';
import Pancakes from 'images/pancakes-sticker.png';

const Stickers = () => {
    const { accountId } = useCurrentAccount();
    const { mutate: updateRewardStatus } = useMutation({ mutationFn: updateRewardStatusApi });

    return (
        <div className="relative overflow-hidden px-6 py-8 text-center">
            <img src={Pancakes} className="absolute right-0 top-10 w-16" alt={'Pancakes sticker'} />
            <img
                src={ChangeMaker}
                className="absolute bottom-0 right-0 w-36"
                alt={'Change maker sticker'}
            />
            <img src={Logo} className="absolute bottom-0 left-0" alt={'Givebutter logo sticker'} />
            <p className="mb-4 text-2xl font-medium text-gray-900">
                Amazing!
                <br />
                You've raised $1,000
            </p>
            <p className="mb-8 text-lg text-gray-500">
                We want to send you some sweet Givebutter stickers to help celebrate!
            </p>

            <a
                className="inline-block"
                target="_blank"
                rel="noreferrer"
                href={`${STICKER_FORM_LINK}${accountId}`}
                onClick={() => updateRewardStatus({ accountId, status: 'claimed' })}
            >
                <Button variant="solid" className="m-auto">
                    Get Stickers
                </Button>
            </a>
        </div>
    );
};

export { Stickers };
